import { render } from "./SearchItemUser.vue?vue&type=template&id=5ef772e1"
import script from "./SearchItemUser.vue?vue&type=script&lang=ts"
export * from "./SearchItemUser.vue?vue&type=script&lang=ts"
script.render = render

export default script